import getCircleBracketsContent from '../../utils/get-circle-brackets-content';
import { dashedToSnakeCase } from '../../utils/convert-case';

const getColorFromVariables = (variableColorKey, variables) => {
  const variableValue = variables[variableColorKey];
  const cssVarRef = getCircleBracketsContent(variableValue);

  return cssVarRef ? variables[dashedToSnakeCase(cssVarRef)] : variableValue;
};

export default getColorFromVariables;
